import { QRCodeSVG } from "qrcode.react";
import { Phone, Mail, Clock, Printer } from "lucide-react";
import { LogoMark } from "../components/Logo";
import { BUSINESS } from "../lib/business";

const Card = ({ children, testId, className = "" }) => (
  <article data-testid={testId} className={`card-sheet relative mx-auto h-[55mm] w-[85mm] overflow-hidden shadow-2xl print:shadow-none ${className}`}>
    {children}
  </article>
);

const Front = () => (
  <Card testId="card-front" className="bg-ink text-bone">
    <div className="absolute inset-0 grid-lines opacity-60" />
    <div className="absolute -right-[10mm] -top-[10mm] h-[40mm] w-[40mm] rounded-full bg-ember/20 blur-2xl" />
    <div className="relative flex h-full flex-col justify-between p-[6mm]">
      <LogoMark className="h-[12mm] w-[12mm]" />
      <div>
        <p className="font-display text-[22px] font-black leading-none tracking-tight">WILKO TECH LTD</p>
        <p className="mt-1.5 font-mono text-[7px] tracking-[0.3em] text-slate-300">REPAIRS & CUSTOM GAMING PCS</p>
        <p className="mt-2 font-display text-[10px] font-bold uppercase text-ember">Dead machines, brought back.</p>
      </div>
    </div>
    <div className="absolute inset-x-0 bottom-0 h-[1.5mm] bg-ember" />
  </Card>
);

const Line = ({ icon: Icon, children }) => (
  <p className="flex items-center gap-1.5 text-[8.5px] font-semibold"><Icon className="h-[3mm] w-[3mm]" />{children}</p>
);

const Back = ({ url }) => (
  <Card testId="card-back" className="bg-ember text-ink">
    <div className="flex h-full items-center justify-between gap-[4mm] p-[6mm]">
      <div className="space-y-[2.2mm]">
        <p className="font-display text-[13px] font-black uppercase leading-none">Repairs & custom PCs</p>
        <p className="text-[7.5px] font-semibold leading-tight">Laptop & desktop repair · Custom gaming PCs built to order</p>
        <Line icon={Phone}>{BUSINESS.phone}</Line>
        <Line icon={Mail}>{BUSINESS.email}</Line>
        <Line icon={Clock}>Mon–Fri · {BUSINESS.hours}</Line>
      </div>
      <div className="shrink-0 text-center">
        <div className="bg-white p-[1.2mm]"><QRCodeSVG value={url} size={78} fgColor="#090D16" level="M" /></div>
        <p className="mt-1 font-mono text-[6.5px] font-bold uppercase tracking-widest">Scan to book</p>
      </div>
    </div>
  </Card>
);

export default function BusinessCards() {
  const qr = new URLSearchParams(window.location.search).get("qr");
  const url = `${qr && qr.startsWith("https://") ? qr : window.location.origin}/request`;
  return (
    <div className="min-h-screen bg-neutral-800 py-10 print:min-h-0 print:bg-white print:p-0">
      <div className="mx-auto mb-6 flex w-[85mm] min-w-[300px] flex-col gap-3 print:hidden">
        <p className="text-sm text-slate-300">Business card 85 × 55 mm · front and back</p>
        <button data-testid="cards-print-btn" onClick={() => window.print()} className="inline-flex items-center justify-center gap-2 bg-ember px-4 py-2.5 text-sm font-semibold text-ink hover:bg-amber-400">
          <Printer className="h-4 w-4" /> Print / Save PDF
        </button>
      </div>
      <div className="space-y-6 print:space-y-0">
        <Front />
        <div className="print:break-before-page"><Back url={url} /></div>
      </div>
    </div>
  );
}
